<template>
	<div class="pa-3 pb-5">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-card class="mb-5">
			<v-card-title class="pb-0">
				<v-text-field
					v-model="inputKeyword"
					prepend-icon="search"
					clearable
					autofocus
					label="ค้นหา Unmanaged Issue"
					type="text">
				</v-text-field>
			</v-card-title>
			<v-card-text>
				<issue-list-all
					:selectable="false"
					:keyword="keyword"
					:issues="issues"
					@edit="handleEdit"
					@delete="handleDelete">
				</issue-list-all>
			</v-card-text>
		</v-card>

		<v-btn fixed dark fab bottom right color="primary" @click="handleAdd">
			<v-icon>add</v-icon>
        </v-btn>

		<v-dialog v-model="toggle.dialog" persistent scrollable max-width="545px">
		    <v-card>
		        <v-card-title class="headline grey lighten-2" primary-title>
		            {{ formTitle }}
		        </v-card-title>
		        <v-card-text>
	            	<v-form ref="form" v-model="valid" lazy-validation>

						<v-text-field v-model="item.title" ref="title" label="Title" append-icon="text_fields"></v-text-field>
						<v-text-field v-model="item.slug" label="Slug" append-icon="sync"></v-text-field>
						<v-text-field v-model="parentIssueTitle" readonly clearable hide-details prepend-icon="add_circle" @click:prepend="selectParentIssue = true" label="Parent Issue"></v-text-field>
						
						<v-switch v-model="item.onlyAdminUsed" label="Only Admin"></v-switch>

		            </v-form>
		        </v-card-text>
				<v-divider></v-divider>
		        <v-card-actions>
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" flat @click="toggle.dialog = false">Cancel</v-btn>
		            <v-btn color="blue darken-1" flat :loading="toggle.saving" @click="handleSave">Save</v-btn>
		        </v-card-actions>
		    </v-card>

			<issue-selection-drawer 
				:show="selectParentIssue" 
				:issues="parentIssues"
				@select="handleSelectParentIssue" 
				@close="selectParentIssue = false">
			</issue-selection-drawer>
		</v-dialog>

        <v-dialog fullscreen persistent v-model="toggle.loading" :transition="false" :content-class="`progress-dialog`">
			<v-progress-circular color="white" :indeterminate="toggle.loading"></v-progress-circular>
		</v-dialog>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

    import IssueListAll from '@/components/IssueListAll.vue'
    import IssueSelectionDrawer from '@/components/IssueSelectionDrawer.vue'

    import debounce from 'tiny-debounce'

	const findById = function(o, id) {
		//Early return
		if (o) {
			if( o.id === id ) {
					return o
			}

			var result, p

			for (p in o) {
				if( o.hasOwnProperty(p) && typeof o[p] === 'object' ) {
					if (o[p]) {
        				result = findById(o[p], id)
        				if (result) {
            				return result
    					}
					}
				}
			}
			return result
		}
	}

	export default {
		components: {
			IssueListAll,
			IssueSelectionDrawer
		},
		data () {
			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Issue',
						disabled: true,
						href: `${config.PUBLIC_PATH}issue`
					},
				],
				inputKeyword: "",
				keyword: "",

				formTitle: "",
				valid: false,
				item: {},
				selectParentIssue: false,
				parentIssueTitle: "",

				toggle: {
					saving: false,
					loading: true,
					dialog: false
				},

				issues: [],
				parentIssues: []
			}
		},
		computed: {

		},
		methods: {
			handleAdd () {
				this.item = {
					id: null,
					title: '',
					slug: '',
					parentId: null,
					parentIssue: null,
					onlyAdminUsed: false
				}

				this.formTitle = 'New Issue'

				this.toggle.dialog = true
				this.$nextTick(() => {
					this.$refs.title.focus()
				})
			},
			handleEdit (issue) {
				this.item = JSON.parse(JSON.stringify(issue))

				if (issue.parentId) {
					axios.get(`${config.BASE_URL}/issue/${issue.parentId}`)
						.then(response => {
							this.parentIssueTitle = response.data.data.title
						})
				} else {
					this.parentIssueTitle = ''
				}

				this.formTitle = 'Edit Issue'

				this.toggle.dialog = true
				this.$nextTick(() => {
					this.$refs.title.focus()
				})
			},
			handleDelete (issue) {
				return false
				
				this.$swal.fire({
					icon: 'warning',
					text: `Remove ${issue.title} ?`,
					showCancelButton: true
				}).then(response => {
					if (response.value) {
						axios.delete(`${config.BASE_URL}/issue/${issue.id}`)
							.then(response => {
								if (issue.parentId) {
									let oldParentIssue = findById(this.issues, issue.parentId)
									oldParentIssue.treeChilds.splice(oldParentIssue.treeChilds.indexOf(issue), 1)
								} else {
									this.issues.splice(this.issues.indexOf(issue), 1)
								}
							})
					}
				})
			},
			handleSave () {
				this.toggle.saving = true

				this.saveData()
					.then(response => {
						let savedIssue = response.data.data

						if (this.item.id) {
							let thisIssue = findById(this.issues, this.item.id)

							if (thisIssue.parentId) {
								let oldParentIssue = findById(this.issues, thisIssue.parentId)
								oldParentIssue.treeChilds.splice(oldParentIssue.treeChilds.indexOf(this.item), 1)
							} else {
								this.issues.splice(this.issues.indexOf(thisIssue), 1)
							}

							thisIssue.title = savedIssue.title
							thisIssue.paentId = savedIssue.parentId
							thisIssue.onlyAdminUsed = savedIssue.onlyAdminUsed
						}

						if (savedIssue.parentId) {
							let parentIssue = findById(this.issues, savedIssue.parentId)

							if (!parentIssue.treeChilds) {
								parentIssue.treeChilds = []
							}
							parentIssue.treeChilds.push(savedIssue)
						} else {
							this.issues.push(savedIssue)
						}

						this.toggle.saving = false
						this.toggle.dialog = false
					})
			},
			saveData() {
				return (this.item.id)
							? axios.put(`${config.BASE_URL}/issue/${this.item.id}`, this.item)
							: axios.post(`${config.BASE_URL}/issue`, this.item)
			},
			handleSelectParentIssue (issue) {
				this.parentIssueTitle = issue.title
				this.item.parentId = issue.id
			},
			reloadIssues () {
				this.toggle.loading = true
                axios.get(`${config.BASE_URL}/issue/tree/all`)
                    .then(response => {
                        this.issues = response.data.data.issueList.splice(0)
                        this.parentIssues = JSON.parse(JSON.stringify(this.issues))
                        this.$nextTick(() => {
                            this.toggle.loading = false
                        })
                    })
            }
		},
		mounted () {
			this.reloadIssues()
		},
		watch: {
            inputKeyword: debounce(function (newVal) {
                this.keyword = newVal
            }, 1000)
		}
	}
</script>

<style lang="scss">
	.v-btn {
		.v-icon {
			padding-right: 0 !important;
		}
	}
	.progress-dialog {
		background: rgba(0, 0, 0, .4);

		[role="progressbar"] {
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
	}
</style>